/**
 * NEWT FORM Consumer API For Consumer UI
 * NEWT FORM コンシューマ UI からコールされる コンシューマ API です。   
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormPagePropertyItemNumberValidatorDigitsRange } from './formPagePropertyItemNumberValidatorDigitsRange';
import { FormPagePropertyItemNumberErrorMessage } from './formPagePropertyItemNumberErrorMessage';
import { FormPagePropertyItemNumberInputFormat } from './formPagePropertyItemNumberInputFormat';


export interface FormPagePropertyItemNumberAllOf { 
    type: FormPagePropertyItemNumberAllOf.TypeEnum;
    /**
     * 入力可能な数値フォーマットを正規表現として表現。 ^[-+]?(0|[1-9]{1}[0-9]{0,})(?:\\\\.[0-9]{0,})?$ ・最初に1つプラス or マイナスがつく可能性がある ・最初は0 or 数字(1-9)から始まる ・間に小数点(.)が一つだけ入る ・最後は小数点 or 数字で終わる 
     */
    pattern: string;
    digitsRange: FormPagePropertyItemNumberValidatorDigitsRange;
    inputFormat: FormPagePropertyItemNumberInputFormat;
    errorMessage?: FormPagePropertyItemNumberErrorMessage;
}
export namespace FormPagePropertyItemNumberAllOf {
    export type TypeEnum = 'string';
    export const TypeEnum = {
        String: 'string' as TypeEnum
    };
}



